var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "training-container",
      class: { "last-step": _vm.isFinalStep }
    },
    [
      _vm.isLoadingAnimatedOutfits
        ? _c("Loader")
        : _c("div", { staticStyle: { height: "100%", width: "100%" } }, [
            _c(
              "div",
              { staticClass: "training-step-body" },
              [
                _vm.isTrainingComplete ? _c("PerfectOutfit") : _vm._e(),
                _vm._v(" "),
                !_vm.isTrainingComplete
                  ? _c("step-" + _vm.currentStep, { tag: "component" })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "training-step-footer" }, [
              _c("div", { staticClass: "button-container" }, [
                _vm.isTrainingComplete || !_vm.isFinalStep
                  ? _c(
                      "div",
                      {
                        staticClass: "button pink next-button",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.nextStep.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.nextButtonText) + "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e71eed24", { render: render, staticRenderFns: staticRenderFns })
  }
}